import { render, staticRenderFns } from "./TributeQR.vue?vue&type=template&id=2e5c544c"
import script from "./TributeQR.vue?vue&type=script&lang=js"
export * from "./TributeQR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports